import { api, ParametersMapLayerMetadata, ParametersModelRun } from "@/lib/api";
import { Dimension } from "@/lib/dimensions";
import {
  getDimensionsFromModelRun,
  getVerticalDimensionFromExtent,
} from "@/lib/dimensions/helpers";

export type ModelLayerDataLoaderData = {
  modelRun: ParametersModelRun;
  meta: ParametersMapLayerMetadata;
  dimensions: Dimension[];
};

export class ModelLayerDataLoader {
  private modelId;
  private mapLayerId;

  constructor(modelId: string, mapLayerId: string) {
    this.modelId = modelId;
    this.mapLayerId = mapLayerId;
  }

  async loadLayerData(): Promise<ModelLayerDataLoaderData> {
    const modelRunResponse = await api.parameters.listModelRuns(this.modelId);
    const layerMetaResponse = await api.parameters.getModeledMapLayerMetadata(
      this.modelId,
      this.mapLayerId,
    );

    const dimensions = [
      ...getDimensionsFromModelRun(modelRunResponse.data[0]),
      getVerticalDimensionFromExtent(layerMetaResponse.data.vertical_extent),
    ].filter((dimension): dimension is Dimension => !!dimension);

    return {
      modelRun: modelRunResponse.data[0],
      meta: layerMetaResponse.data,
      dimensions,
    };
  }
}
